// 动态译文管理：英文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 译文审核
export const management = Object.freeze({
  "businessTranslation.generated": "Generation complete",
  "businessTranslation.autoPublish": "Automatic publication is enabled. AI translations appear after validation without manual review.",
  "businessTranslation.sellerCompany": "Seller company name",
  "businessTranslation.productTitle": "Product title",
  "businessTranslation.mallGoodsId": "Marketplace product ID (goods_id)",
  "businessTranslation.title": "Company / product content translations",
  "businessTranslation.hint":
    "Translations are for display and keep business originals unchanged. When automatic publication is enabled, validated AI translations are published directly and can still be corrected.",
  "businessTranslation.aiHint":
    "AI translates text only, not attachments or HTML attributes. The current limit is 8 text nodes and 10,000 characters in total; use manual candidates for larger content.",
  "businessTranslation.transferConfirmation":
    "I confirm this original may be sent to the configured translation model and contains no unauthorized private or contract material",
  "businessTranslation.aiUnavailable":
    "Generation configuration is unavailable or the content exceeds the budget. Manual candidates remain available.",
  "businessTranslation.jobs": "Latest 20 content generation jobs",
  "businessTranslation.jobQueued":
    "Queued for background generation. The current publication policy applies when complete.",
  "businessTranslation.type": "Content type",
  "businessTranslation.company": "Company introduction",
  "businessTranslation.product": "Product HTML content",
  "businessTranslation.id": "Actual company / product library ID",
  "businessTranslation.approve": "Approve reviewed English version",
  "businessTranslation.preview":
    "Display preview for the current interface language (HTML shown as source text)",
  "businessTranslation.NOT_REQUESTED": "Chinese original",
  "businessTranslation.NONE": "English translation",
  "businessTranslation.TRANSLATION_MISSING":
    "No English translation available; showing the original",
  "businessTranslation.SOURCE_CHANGED":
    "Original changed; old translation is not displayed",
  "businessTranslation.SOURCE_UNLINKED":
    "No reliable product library link; showing the original",
  "businessTranslation.TRANSLATION_UNAVAILABLE":
    "Translation unavailable; showing the original",
  "contractTranslation.title": "Contract translation reading-aid ledger",
  "contractTranslation.hint":
    "Admins may compare originals and save reading-aid candidates. These do not replace the original contract. Independent approval is paused while there is only one administrator; no temporary review account is needed.",
  "contractTranslation.id": "Contract database ID (not contract number)",
  "contractTranslation.attachments": "Linked original byte digests",
  "contractTranslation.originalHint":
    "Digests are not attachment contents. Compare actual attachments, all terms and key facts through the original contract page before approval. Immutable originals and OCR comparison are not provided here.",
  "contractTranslation.note": "Review note (required for both decisions)",
  "contractTranslation.facts":
    "I compared the actual originals, amounts, dates, identifiers, accounts and all terms, and confirmed this is a reading aid only",
  "contractTranslation.approve": "Approve reading aid (not public)",
  "contractTranslation.empty": "No contract translation candidates",
  "contractTranslation.PENDING_REVIEW": "Awaiting independent review",
  "contractTranslation.REVIEWED": "Reviewed reading aid",
  "contractTranslation.REJECTED": "Rejected",
  "contractTranslation.independent":
    "You cannot review your own submission. Independent approval is paused while there is only one administrator.",
  "contractTranslation.originalUnavailable":
    "Actual originals cannot be fully verified. Submission and approval are unavailable; historical candidates remain readable.",
  "contractTranslation.mismatch":
    "Key facts are missing or changed. Compare the originals and submit a new candidate.",
  "contractTranslation.invalid":
    "Load the actual contract originals and enter an English candidate",
  "contentTranslation.candidates":
    "Latest 20 candidates (including manual drafts)",
  "contentTranslation.title": "Content translations",
  "contentTranslation.category": "Product category description",
  "contentTranslation.source": "Current Chinese original",
  "contentTranslation.candidateSource": "Original bound to this candidate",
  "contentTranslation.english": "English candidate",
  "contentTranslation.generate": "Generate English candidate",
  "contentTranslation.manual": "Save manual candidate",
  "contentTranslation.refresh": "Refresh jobs",
  "contentTranslation.jobs": "Latest 20 generation jobs",
  "contentTranslation.open": "Compare and review",
  "contentTranslation.approve": "Approve and publish",
  "contentTranslation.reject": "Reject",
  "contentTranslation.note": "Review note (required for rejection)",
  "contentTranslation.empty": "No generation jobs",
  "contentTranslation.failed": "Translation operation failed. Please retry.",
  "contentTranslation.saved": "Candidate saved, not yet public",
  "contentTranslation.reviewed": "Review decision saved",
  "contentTranslation.queued": "Job queued. Refresh to check its result.",
  "contentTranslation.confirm":
    "Confirm terminology, numbers and part numbers have been checked. Approval publishes this version for English display.",
  "contentTranslation.stale":
    "The original changed or this candidate is final. Create a new candidate for the current original.",
  "contentTranslation.disabled":
    "Generation versions are not configured. Manual candidates remain available; no model version is inferred.",
  "contentTranslation.hint":
    "AI generates candidates only. Approval does not rewrite the Chinese original. Contracts and attachments are excluded.",
  "contentTranslation.PENDING": "Pending",
  "contentTranslation.RUNNING": "Generating",
  "contentTranslation.GENERATED": "Awaiting review",
  "contentTranslation.STALE": "Source changed",
  "contentTranslation.FAILED": "Failed",
  "contentTranslation.PUBLISHED": "Published",
  "contentTranslation.REJECTED": "Rejected",
  "contentTranslation.invalid":
    "Select a category with original text and enter an English candidate",
});

export const messages = Object.freeze({ ...management });
